import { ForwardedRef, HTMLAttributes, forwardRef, useState } from 'react';
import clsx from 'clsx';
import CurrencyInput from 'react-currency-input-field';
import { Control, Controller, ControllerProps } from 'react-hook-form';
import { ErrorFormField } from '../types';

type CurrencyNumberInputProps = HTMLAttributes<HTMLDivElement> &
  ErrorFormField & {
    defaultValue?: string | number;
    [key: string]: any;
  };

const CurrencyNumberInput = forwardRef((props: CurrencyNumberInputProps, ref: ForwardedRef<HTMLInputElement>) => {
  const { className, intlConfig = { locale: 'en-GB', currency: 'GBP' }, value, onChange, ...extraProps } = props;
  const [inputValue, setInputValue] = useState(value);

  /**
   * methods
   */

  // value input change
  const valueChangeAction = (value) => {
    setInputValue(value);
    if (onChange) onChange(value);
  };

  return (
    <CurrencyInput
      ref={ref}
      className={clsx('numeric-font-fix border-[rgba(0, 0, 0, 0.23)] peer h-12 w-full rounded-md border px-4 font-medium text-gray-900 focus:outline-none focus:ring-0', className)}
      value={inputValue}
      intlConfig={intlConfig}
      onValueChange={valueChangeAction}
      {...extraProps}
    />
  );
});

type ControlledProps = Omit<ControllerProps, 'control' | 'render'> &
  CurrencyNumberInputProps & {
    control: Control<any>;
  };

export const CurrencyNumberInputControlled = forwardRef(({ control, name, ...props }: ControlledProps, ref: ForwardedRef<HTMLInputElement>) => {
  return (
    <Controller
      name={name}
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return <CurrencyNumberInput {...props} ref={ref} value={value} onChange={onChange} error={!!error} errMessage={error?.message} />;
      }}
    />
  );
});

export default CurrencyNumberInput;
